<template>
  <div class="block yfhw-page17 f-r f-c">
    <PageHeader
      :title="moduleData['3_24_1_1']"
      :sub-title="moduleData['3_24_1_1_en']"
      :page-logo="reportCustomization.pageLogo"
    />
    <PageTips :page-num="pageNum"/>

    <div class="content-container">
      <div class="head-container">
        <div class="left-container">
          <div class="block">
            <div class="header">客流量（日均）</div>
            <div class="content"><div>{{ dailyFlowValue || '--' }}万人</div></div>
          </div>

          <div class="block">
            <div class="header">消费等级</div>
            <div class="content"><div>{{ consumptionLevelValue || '--' }}</div></div>
          </div>
        </div>

        <div class="right-container">
          <div class="chart-block">
            <div class="title">
              <div>收入区间分布</div>
              <div class="income">收入总体均值：{{ incomeTotal }}元</div>
            </div>
            <Empty v-if="barIncomeEmpty" class="empty-container"></Empty>
            <VChart
              v-else
              style="width: 100%; height: 90%"
              :option="barIncomeOption"
            ></VChart>
          </div>

          <div class="chart-block">
            <div class="title">
              <div>月消费区间</div>
              <div class="income wallet">月消费总体均值：{{ consumptionTotal }}元</div>
            </div>
            <Empty v-if="barConsumptionEmpty" class="empty-container"></Empty>
            <VChart
              v-else
              style="width: 100%; height: 90%"
              :option="barConsumptionOption"
            ></VChart>
          </div>
        </div>
      </div>

      <div class="tail-container">
        <div class="exp-title">数据说明：</div>
        <div class="exp">
          客流量：指在一个季度内，区域内平均每天到访的访客数量。
        </div>
        <div class="exp">
          消费能力：以房价作为区域消费能力的代理指标，房价越高代表该片区居民购买力越强，商圈消费潜力越高；500 米为门店核心辐射范围，代表门店日常主要触达客群的居住圈层。
        </div>
        <div class="exp">
          消费区间分布：指目标客群消费区间占比分布（所选时间段内的月消费），通过到访线下消费场所的客单价、次数等进行综合建模推算。
        </div>
        <div class="exp">
          收入区间：指目标客群收入区间占比分布（所选时间段内的月收入），通过目标客群消费情况以及居住房价、车价、手机价格、是否出入高端消费场所等进行综合建模推算。
        </div>
      </div>
    </div>

    <div v-if="reportCustomization.showDataSource" class="page-bottom-tips">
      数据来源：位置厂商数据结合边界自有模型测算
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'

import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import Empty from "./components/Empty"

const props = defineProps({
  pageNum: String,
  moduleData: {
    type: Object,
    default: () => {}
  },
  reportCustomization: {
    type: Object,
    default: () => {},
  },
  commonLang: {
    type: String,
    default: 'zh',
  },
  yfhwData: {
    type: Object,
    default: () => {},
  },
});

// 左侧数据
const dailyFlowValue = ref('')
const consumptionLevelValue = ref('')
const incomeTotal = ref('')
const consumptionTotal = ref('')

// 收入区间分布
const barIncomeEmpty = ref(false)
const barIncomeOption = ref()

// 月消费区间
const barConsumptionEmpty = ref(false)
const barConsumptionOption = ref()

const wrapData = () => {
  const { dailyPFlow, consumptionLevel, incomeAvg, consumptionAvg, incomeList, consumptionList } = props.yfhwData

  dailyFlowValue.value = dailyPFlow
  consumptionLevelValue.value = consumptionLevel
  incomeTotal.value = incomeAvg
  consumptionTotal.value = consumptionAvg

  barIncomeEmpty.value = !incomeList.length
  barIncomeOption.value = {
    grid: {
      top: 40,
      left: 94,
      bottom: 60,
      right: 30,
    },
    xAxis: {
      type: 'category',
      data: incomeList.map((i) => i.key),
      axisLabel: {
        color: '#595959',
        interval: 0,
        fontSize: '14px',
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        show: true,
        formatter: '{value} %',
        fontSize: '14px',
      },
    },
    series: {
      type: 'bar',
      data: incomeList.map((i) => i.value),
      barWidth: 42,
      itemStyle: {
        color: '#17C49D',
      },
      label: {
        show: true,
        formatter(param) {
          return param.value + '%'
        },
        position: 'top',
        color: '#595959',
        fontSize: '18px',
      },
    },
  }

  barConsumptionEmpty.value = !consumptionList.length
  barConsumptionOption.value = {
    grid: {
      top: 40,
      left: 94,
      bottom: 60,
      right: 30,
    },
    xAxis: {
      type: 'category',
      data: consumptionList.map((i) => i.key),
      axisLabel: {
        color: '#595959',
        interval: 0,
        fontSize: '14px',
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        show: true,
        formatter: '{value} %',
        fontSize: '14px',
      },
    },
    series: {
      type: 'bar',
      data: consumptionList.map((i) => i.value),
      barWidth: 42,
      itemStyle: {
        color: '#4B86FF',
      },
      label: {
        show: true,
        formatter(param) {
          return param.value + '%'
        },
        position: 'top',
        color: '#595959',
        fontSize: '18px',
      },
    },
  }
}

onMounted(() => {
  wrapData()
})
</script>
<style scoped lang="less">
.yfhw-page17 {
  position: relative;
  background: #ffffff;
  padding: 26px 60px 32px 0;

  .content-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 30px 60px 0;
    width: 100%;

    .head-container {
      flex: 1;
      display: flex;
      justify-content: space-around;

      .title {
        margin-left: 22px;
        font-size: 24px;
        color: rgba(0, 0, 0, 0.88);
      }

      .left-container {
        width: 39%;
        display: flex;
        flex-direction: column;

        .block {
          flex: 1;
          display: flex;
          flex-direction: column;
          background: #F6F7FA;

          .header {
            padding: 8px 20px;
            font-size: 24px;
            font-weight: 500;
            color: #FFFFFF;
            background: #333333;
            border-left: 15px solid #FFDB00;
          }

          .content {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 66px;
            font-weight: 500;
            color: #3D3D3D;
          }
        }
        .block + .block {
          margin-top: 18px;
        }
      }

      .right-container {
        display: flex;
        flex-direction: column;
        width: 59%;
        height: 100%;

        .chart-block {
          flex: 1;
          width: 100%;

          .title {
            display: flex;
            align-items: center;
            width: 100%;
            line-height: 34px;
          }
        }

        .income {
          margin: 0 20px;
          padding: 8px 16px 8px 64px;
          width: max-content;
          line-height: 34px;
          font-size: 24px;
          font-weight: 500;
          color: #2c75f2;

          border-radius: 8px;
          background-color: #F6F7FA;
          background-image: url("@/assets/report-v2/yfhw/ic-money.svg");
          background-size: 28px 28px;
          background-position: 24px center;
          background-repeat: no-repeat;

          &.wallet {
            background-image: url("@/assets/report-v2/yfhw/ic-wallet.svg");
          }
        }
      }
    }

    .tail-container {
      flex-shrink: 0;
      margin-top: 18px;
      padding: 10px 24px 20px;
      border: 1px solid rgba(0, 0, 0, 0.07);
      border-radius: 16px;

      .exp-title {
        font-size: 24px;
        color: #333333;
        margin-top: 16px;
        margin-left: 20px;
      }

      .exp {
        font-size: 18px;
        margin-top: 10px;
        margin-left: 20px;
        color: #333333;
      }

      .exp::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        vertical-align: middle;
        background-color: #2c75f2;
      }
    }
  }

  .empty-container {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>
